import _slicedToArray from "/vercel/path1/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/slicedToArray.js";
import _asyncToGenerator from "/vercel/path1/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js";
import React from "react";
var __jsx = React.createElement;
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
import AwesomeIcon from "../AwesomeIcon";
import { faEdit, faCheck, faTimes, faTrash } from "@fortawesome/pro-regular-svg-icons";
import { useState } from "react";
import { format } from "date-fns";
import { TagInput, TagNumberInput, TagNumberInputWithLogic, TagDateInput, TagDateInputWithLogic, TagDropdownInput, TagMultiDropdownInput, TagBooleanInput, TagUserInput } from "./AiTagInputs";
import { getLogicSymbol } from "../PatientTags/constants";
var AiTagItem = function AiTagItem(_ref) {
  var _field$additional;
  var field = _ref.field,
    value = _ref.value,
    isEditing = _ref.isEditing,
    onEdit = _ref.onEdit,
    onSave = _ref.onSave,
    onCancel = _ref.onCancel,
    onValueChange = _ref.onValueChange,
    onRemove = _ref.onRemove,
    disableEditing = _ref.disableEditing,
    logic = _ref.logic,
    onLogicChange = _ref.onLogicChange,
    _ref$showLogic = _ref.showLogic,
    showLogic = _ref$showLogic === void 0 ? false : _ref$showLogic;
  var _useState = useState(false),
    isUpdating = _useState[0],
    setIsUpdating = _useState[1];
  var isSpecialLayout = ((field === null || field === void 0 ? void 0 : field.tag_type) === "date" || (field === null || field === void 0 ? void 0 : field.tag_type) === "integer" || (field === null || field === void 0 ? void 0 : field.tag_type) === "float") && showLogic && isEditing;
  var isNumberLayout = (field === null || field === void 0 ? void 0 : field.tag_type) === "integer" || (field === null || field === void 0 ? void 0 : field.tag_type) === "float";
  var handleValueChange = function handleValueChange(newValue) {
    var processedValue = newValue;
    if ((field === null || field === void 0 ? void 0 : field.tag_type) === "integer") {
      processedValue = newValue ? parseInt(newValue, 10) : null;
    } else if ((field === null || field === void 0 ? void 0 : field.tag_type) === "float") {
      processedValue = newValue ? parseFloat(newValue) : null;
    }
    onValueChange(processedValue);
  };
  var handleSave = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
      return _regenerator().w(function (_context) {
        while (1) switch (_context.p = _context.n) {
          case 0:
            setIsUpdating(true);
            _context.p = 1;
            _context.n = 2;
            return onSave();
          case 2:
            _context.p = 2;
            setIsUpdating(false);
            return _context.f(2);
          case 3:
            return _context.a(2);
        }
      }, _callee, null, [[1,, 2, 3]]);
    }));
    return function handleSave() {
      return _ref2.apply(this, arguments);
    };
  }();
  var formatDisplayValue = function formatDisplayValue(value, tagType, logic) {
    if (typeof value === "boolean") {
      return value ? "Yes" : "No";
    } else if (Array.isArray(value)) {
      if (tagType === "date" && logic === "between" && value.length === 2) {
        var _value = _slicedToArray(value, 2),
          startDate = _value[0],
          endDate = _value[1];
        if (startDate && endDate) {
          var formattedStart = format(new Date(startDate), "MMM dd, yyyy");
          var formattedEnd = format(new Date(endDate), "MMM dd, yyyy");
          return "Between ".concat(formattedStart, " - ").concat(formattedEnd);
        } else if (startDate) {
          var _formattedStart = format(new Date(startDate), "MMM dd, yyyy");
          return "After ".concat(_formattedStart);
        } else if (endDate) {
          var _formattedEnd = format(new Date(endDate), "MMM dd, yyyy");
          return "Before ".concat(_formattedEnd);
        }
        return "Select date range";
      }
      return value.join(", ");
    } else if (value != null && value !== "" && showLogic && (tagType === "integer" || tagType === "float" || tagType === "date")) {
      var logicSymbol = getLogicSymbol(logic || "", tagType);
      if (tagType === "date" && value) {
        try {
          var formattedDate = format(new Date(value), "MMM dd, yyyy");
          return "".concat(logicSymbol).concat(formattedDate);
        } catch (error) {
          return "".concat(logicSymbol).concat(value);
        }
      }
      return "".concat(logicSymbol).concat(value);
    } else {
      if (tagType === "date" && value) {
        try {
          return format(new Date(value), "MMM dd, yyyy");
        } catch (error) {
          return value;
        }
      }
      return value;
    }
  };
  var renderEditInput = function renderEditInput() {
    switch (field === null || field === void 0 ? void 0 : field.tag_type) {
      case "string":
        return /*#__PURE__*/React.createElement(TagInput, {
          value: value,
          onChange: handleValueChange,
          field: field
        });
      case "integer":
        return showLogic ? /*#__PURE__*/React.createElement(TagNumberInputWithLogic, {
          value: value,
          onChange: handleValueChange,
          field: field,
          logic: logic,
          onLogicChange: onLogicChange,
          inputClassName: "px-[12px] !py-[7px] flex items-center"
        }) : /*#__PURE__*/React.createElement(TagNumberInput, {
          value: value,
          onChange: handleValueChange,
          field: field
        });
      case "float":
        return showLogic ? /*#__PURE__*/React.createElement(TagNumberInputWithLogic, {
          value: value,
          onChange: handleValueChange,
          field: field,
          logic: logic,
          onLogicChange: onLogicChange,
          inputClassName: "px-[12px] !py-[7px] flex items-center"
        }) : /*#__PURE__*/React.createElement(TagNumberInput, {
          value: value,
          onChange: handleValueChange,
          field: field
        });
      case "date":
        return showLogic ? /*#__PURE__*/React.createElement(TagDateInputWithLogic, {
          value: value,
          onChange: handleValueChange,
          field: field,
          logic: logic,
          onLogicChange: onLogicChange
        }) : /*#__PURE__*/React.createElement(TagDateInput, {
          value: value,
          onChange: handleValueChange,
          field: field
        });
      case "single_dropdown":
        return /*#__PURE__*/React.createElement(TagDropdownInput, {
          value: value,
          onChange: handleValueChange,
          field: field
        });
      case "multi_dropdown":
        return /*#__PURE__*/React.createElement(TagMultiDropdownInput, {
          value: value,
          onChange: handleValueChange,
          field: field,
          title: Array.isArray(value) ? value.join(", ") : value,
          dropdownMenuClassName: "!w-[120px]"
        });
      case "boolean":
        return /*#__PURE__*/React.createElement(TagBooleanInput, {
          value: value,
          onChange: handleValueChange,
          field: field
        });
      case "user":
        return /*#__PURE__*/React.createElement(TagUserInput, {
          value: value,
          onChange: handleValueChange,
          field: field
        });
      default:
        return null;
    }
  };
  return /*#__PURE__*/React.createElement("div", {
    className: "relative group cursor-pointer transition-all duration-200 justify-center \n      ".concat(isSpecialLayout ? "flex flex-col w-full 3xl:flex-row 3xl:w-auto 3xl:min-w-[90px] rounded-lg 3xl:rounded-full" : "flex items-center min-w-[90px] rounded-full", "\n      gap-2 px-3 py-1.5 bg-white dark:bg-gray-700 text-gray-800 dark:text-gray-200 text-[14px] border border-gray-200 dark:border-gray-600")
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex items-center justify-between ".concat(isSpecialLayout && logic !== "between" && !isNumberLayout ? "w-full" : "")
  }, /*#__PURE__*/React.createElement("span", {
    className: "font-medium text-[12px]",
    title: (field === null || field === void 0 ? void 0 : field.tag.length) > 30 ? field === null || field === void 0 ? void 0 : field.tag : undefined
  }, (field === null || field === void 0 ? void 0 : field.tag.length) > 30 ? "".concat(field === null || field === void 0 ? void 0 : field.tag.substring(0, 30), "...:") : "".concat(field === null || field === void 0 ? void 0 : field.tag, ":")), isSpecialLayout && /*#__PURE__*/React.createElement("div", {
    className: "flex 3xl:hidden items-center gap-2"
  }, /*#__PURE__*/React.createElement("button", {
    onClick: function onClick(e) {
      e.stopPropagation();
      handleSave();
    },
    disabled: isUpdating,
    title: "Save",
    className: "text-green-400 hover:text-green-200 text-[14px] ".concat(isUpdating ? "opacity-50 cursor-not-allowed" : "")
  }, /*#__PURE__*/React.createElement(AwesomeIcon, {
    name: faCheck
  })), /*#__PURE__*/React.createElement("button", {
    onClick: function onClick(e) {
      e.stopPropagation();
      onCancel();
    },
    disabled: isUpdating,
    title: "Cancel",
    className: "text-red-400 hover:text-red-200 text-[14px] ".concat(isUpdating ? "opacity-50 cursor-not-allowed" : "")
  }, /*#__PURE__*/React.createElement(AwesomeIcon, {
    name: faTimes
  })))), isEditing ? /*#__PURE__*/React.createElement("div", {
    className: "flex items-center gap-2 w-full"
  }, renderEditInput(), /*#__PURE__*/React.createElement("div", {
    className: "items-center gap-2 ".concat(isSpecialLayout ? "hidden 3xl:flex" : "flex")
  }, /*#__PURE__*/React.createElement("button", {
    onClick: function onClick(e) {
      e.stopPropagation();
      handleSave();
    },
    disabled: isUpdating,
    title: "Save",
    className: "text-green-400 hover:text-green-200 text-[14px] ".concat(isUpdating ? "opacity-50 cursor-not-allowed" : "")
  }, /*#__PURE__*/React.createElement(AwesomeIcon, {
    name: faCheck
  })), /*#__PURE__*/React.createElement("button", {
    onClick: function onClick(e) {
      e.stopPropagation();
      onCancel();
    },
    disabled: isUpdating,
    title: "Cancel",
    className: "text-red-400 hover:text-red-200 text-[14px] ".concat(isUpdating ? "opacity-50 cursor-not-allowed" : "")
  }, /*#__PURE__*/React.createElement(AwesomeIcon, {
    name: faTimes
  })))) : /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("span", {
    className: "text-[12px]"
  }, formatDisplayValue(value, field === null || field === void 0 ? void 0 : field.tag_type, logic)), !disableEditing && /*#__PURE__*/React.createElement("div", {
    className: "absolute right-1 flex items-center gap-1 opacity-0 group-hover:opacity-100 transition-opacity duration-200 bg-white/90 dark:bg-gray-700/90 backdrop-blur-sm rounded-full px-1 py-0.5 shadow-sm"
  }, (field === null || field === void 0 || (_field$additional = field.additional) === null || _field$additional === void 0 ? void 0 : _field$additional.isEditable) && !!onEdit && /*#__PURE__*/React.createElement("button", {
    onClick: function onClick(e) {
      e.stopPropagation();
      onEdit();
    },
    className: "text-gray-500 hover:text-gray-700 text-[12px] p-1 rounded-full hover:bg-gray-100 dark:hover:bg-gray-600 transition-colors"
  }, /*#__PURE__*/React.createElement(AwesomeIcon, {
    name: faEdit
  })), !!onRemove && /*#__PURE__*/React.createElement("button", {
    onClick: function onClick(e) {
      e.stopPropagation();
      onRemove();
    },
    className: "text-gray-500 hover:text-red-500 text-[12px] p-1 rounded-full hover:bg-gray-100 dark:hover:bg-gray-600 transition-colors"
  }, /*#__PURE__*/React.createElement(AwesomeIcon, {
    name: faTrash
  })))));
};
export default AiTagItem;